module.exports = __webpack_public_path__ + "static/media/landscape7.5946926c.jpg";